import React from 'react'
import { useHistory } from 'react-router-dom'
import {
  Modal,
  Form,
  Input,
  Button,
  Select,
  Layout,
  Row,
  Col
} from 'antd'
import API from '../../../../api/index'
import Header from '../../../Header'
import Maps from '../../../maps/Maps'
import Geosuggest from 'react-geosuggest'

const { Content } = Layout

const BranchUpdate = (props) => {
  const { push } = useHistory()
  const [idTrade, setIdTrade] = React.useState(undefined)
  const [nameTrade, setNameTrade] = React.useState(undefined)
  const [name, setName] = React.useState(undefined)
  const [city, setCity] = React.useState(undefined)
  const [address, setAddress] = React.useState(undefined)
  const [addressProps, setAddressProps] = React.useState(undefined)
  const [errorAddress, setErrorAddress] = React.useState(undefined)
  const [country, setCountry] = React.useState(undefined)
  const [state, setState] = React.useState(undefined)
  const [cellphone, setCellphone] = React.useState(undefined)
  const [user, setUser] = React.useState(undefined)
  const [listUser, setListUser] = React.useState([])
  const [idCity, setIdCity] = React.useState([])
  const [idCountry, setIdCountry] = React.useState([])
  const [idState, setIdState] = React.useState([])
  const [lat, setLat] = React.useState(undefined)
  const [lng, setLng] = React.useState(undefined)
  const id = props.match.params.id


  const createRow = (values) => {
    let row = []
    values.map(value => {
      return row.push(<Select.Option value={value._id} key={value._id}>{value.name}</Select.Option>)
    })
    return row
  }

  const createRowUser = (values) => {
    let row = []
    values.map(value => {
      return row.push(<Select.Option value={value._id} key={value._id}>{value.first_name + 
        ' ' + value.last_name}</Select.Option>)
    })
    return row
  }

  const User = async () => {
    const users = await API.trade.getOperators(idTrade)
    setListUser(users)
  }

  const Country = async () => {
    const idCountry = await API.country.list()
    setIdCountry(idCountry)
  }

  const stateC = async (country = country) => {
    if (country) {
      const idState = await API.state.list(country)
      setIdState(idState)
    }
  }

  const City = async (state = state) => {
    if (state) {
      const idCity = await API.city.list(state)
      setIdCity(idCity)
    }
  }

  const onSubmit = async () => {
    clearErrors()
    let address
    if (address !== addressProps) {
      address = address
    }
    const response = await API.branchOffice.update(id, {
      name: name,
      city: city,
      address: address,
      cellphone: cellphone,
      user: user,
      gps: `${lat},${lng}`
    })
    if (response.ok) {
      Modal.success({
        title: 'Actualización de una sucursal',
        content: `La sucursal ${name} fue actualizada exitosamente`
      })
      clearErrors()
    }
    if (response.errors) {
      makeErrors(response.errors)
    }
  }

  const makeErrors = (error) => {
    if (error.address) {
      setErrorAddress(error.address.message)
    }
  }

  const clearErrors = () => {
    setErrorAddress(undefined)
  }

  const handleChangeCountry = (value) => {
    setCountry(value)
    stateC(value)
  }

  const handleChangeState = (value) => {
    setState(value)
    City(value)
  }

  const handleMaps = (latitude, longitude) => {
    setLat(latitude)
    setLng(longitude)
  }

  const getBranch = async () => {
    const branches = await API.branchOffice.detail(id)
    setName(branches.name)
    if (branches.idTrade) {
      setIdTrade(branches.idTrade._id)
      setNameTrade(branches.idTrade.trade_name)
      User()
    }
    const users = []
    for (let index = 0; index < branches.users.length; index++) {
      const user = branches.users[index]
      users.push(user._id)
    }
    setUser(users)
    setCellphone(branches.cellphone)
    if (branches.city) {
      setCity(branches.city._id)
      setCountry(branches.country._id)
      setState(branches.state._id)
      stateC(branches.country._id)
      City(branches.state._id)
    }
    let lat
    let lng
    if (branches.gps) {
      const gpsState = branches.gps
      lat = parseFloat(gpsState[0])
      lng = parseFloat(gpsState[1])
    }
    setLat(lat)
    setLng(lng)
    setAddress(branches.address)
    setAddressProps(branches.address)
  }

  const onSuggestSelect = (data) => {
    setAddress(undefined)
    setLat(undefined)
    setLng(undefined)

    if (data) {
      setAddress(data.description)
      setLat(data.location.lat)
      setLng(data.location.lng)
    }
  }

  React.useEffect(() => {
    Country()
    getBranch()
  }, [])

  const cityRow = createRow(idCity)
  const stateRow = createRow(idState)
  const countryRow = createRow(idCountry)
  const userRow = createRowUser(listUser)

  return (
    <Layout className='layout'>
      <Header item='trade' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <Row style={{ marginBottom: '20px' }}>
            <Col span={8}>
              <h3><strong>Actualizar sucursal</strong></h3>
            </Col>
            <Col span={8} offset={8} style={{ textAlign: 'right' }}>
              <Button
                onClick={() => push(`/branchesmerchant/list/${idTrade}`)}
              >
                Regresar
              </Button>
              {' '}
              <Button onClick={() => onSubmit()}>Editar</Button>
            </Col>
          </Row>
          <Form
            layout='vertical'
          >
            <Row>
              <Col span={7} offset={1} >
                <Form.Item
                  label='Comercio'
                >
                  <Input
                    disabled
                    placeholder={nameTrade}
                  />
                </Form.Item>
              </Col>
              <Col span={7} offset={1} >
                <Form.Item
                  label='Nombre'
                >
                  <Input
                    type='text'
                    onChange={(event) => setName(event.target.value)}
                    value={name}
                  />
                </Form.Item>
              </Col>
              <Col span={7} offset={1} >
                <Form.Item
                  label='País'
                >
                  <Select
                    showSearch
                    type='text'
                    style={{ width: '100%' }}
                    placeholder='Seleccione un país'
                    onChange={(value) => handleChangeCountry()}
                    value={country}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {countryRow}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={7} offset={1} >
                <Form.Item
                  label='Estado'
                >
                  <Select
                    showSearch
                    type='text'
                    style={{ width: '100%' }}
                    placeholder='Seleccione una estado'
                    onChange={(value) => handleChangeState(value)}
                    value={state}
                    filterOption={(input, option) => 
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {stateRow}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={7} offset={1} >
                <Form.Item
                  label='Ciudad'
                >
                  <Select
                    showSearch
                    type='text'
                    style={{ width: '100%' }}
                    placeholder='Seleccione una ciudad'
                    onChange={(value) => setCity(value)}
                    value={city}
                    filterOption={(input, option) => 
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {cityRow}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={7} offset={1} >
                <Form.Item
                  label='Teléfono'
                >
                  <Input
                    type='text'
                    onChange={(event) => setCellphone(event.target.value)}
                    value={cellphone}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={7} offset={1} >
                <Form.Item
                  label='Operador(es)'
                >
                  <Select mode='multiple'
                    showSearch
                    type='text'
                    style={{ width: '100%' }}
                    placeholder='Seleccione una usuario'
                    onChange={(value) => setUser(value)}
                    value={user}
                    filterOption={(input, option) => 
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {userRow}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={7} offset={1}>
                <Form.Item
                  label='Dirección*'
                  validateStatus={errorAddress && ('error')}
                  help={errorAddress}
                >
                  <Geosuggest
                    placeholder={address || 'Ingrese la dirección'}
                    onSuggestSelect={onSuggestSelect}
                    location={new window.google.maps.LatLng(4.6979319, -74.0780855)}
                    radius={20}
                    inputClassName='ant-input'
                  />
                </Form.Item>
              </Col>
              <Col span={7} offset={1}>
                <Form.Item
                  label='Ubicación'
                >
                  {address && (<Maps lat={lat} lng={lng} handleMaps={handleMaps} />)}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Content>
    </Layout>
  )
}

export default BranchUpdate
